import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Input from '../ui/Input';
import 'react-phone-number-input/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import i18n from '../../i18n';
import { Circles } from "react-loader-spinner";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
//import { FaApple } from "react-icons/fa";
import { loginUser } from '../../features/auth/loginSlice';
import { FcGoogle } from "react-icons/fc";
import { E164Number } from 'libphonenumber-js';
import PhoneInput from 'react-phone-number-input';
import { useGoogleLogin } from '@react-oauth/google';
import { apiRequest } from '../../utils/data';
import { GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
// import { OAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from '../../firebase';
import Cookies from 'js-cookie';
import { setUser } from '../../features/auth/userSlice';
import { useSEO } from '../../custom hooks/useSEO';
const LoginForm = () => {
    const { t } = useTranslation();
    const { t: tSeo } = useTranslation("seo");
    const { siteInfo } = useSelector((state: RootState) => state.settingSlice);
    const seo = useSEO({
        title: `${siteInfo?.siteName} | ${tSeo("login.title")}`,
        description: tSeo("login.description")
    });
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { loading } = useSelector((state: RootState) => state.login);

    const [phone, setPhone] = useState<E164Number | undefined>();
    const [password, setPassword] = useState("");
    const loginWithGoogle = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                const credential = GoogleAuthProvider.credential(null, tokenResponse.access_token);
                const firebaseResult = await signInWithCredential(auth, credential);
                const idToken = await firebaseResult.user.getIdToken();
                const response = await apiRequest("Authentication/loginWithGoogle", {
                    method: "POST",
                    body: { idToken },
                });
                Cookies.set('accessToken', response.data.token, { expires: 7 });
                Cookies.set('userId', response.data.id, { expires: 7 });
                dispatch(setUser(response.data));
                navigate('/');

            } catch (error) {
                console.error("Google login failed:", error);
            }
        },
    });
/*     const loginWithApple = async () => {
  try {
    const provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');

    const result = await signInWithPopup(auth, provider);

    const idToken = await result.user.getIdToken();

    const response = await apiRequest("Authentication/loginWithApple", {
      method: "POST",
      body: { idToken },
    });

    Cookies.set('accessToken', response.data.token, { expires: 7 });
    Cookies.set('userId', response.data.id, { expires: 7 });

    dispatch(setUser(response.data));
    navigate('/');

  } catch (error) {
    console.error("Apple login failed:", error);
  }
}; */

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const cleanPhone = phone ? phone.toString().trim() : "";
        const cleanPassword = password.trim();
        dispatch(loginUser({ data: { phone: cleanPhone, password: cleanPassword }, navigate, dispatch }));
    };

    return (
        <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
            {seo}
            <div className='padding-container'>
                <div className=' mb-5'>
                    <h1 className=' text-4xl font-bold'>{t("login")}</h1>
                    <p className=' text-lg text-textSecond mt-4'>{t("login-subheading")}</p>
                </div>
                <form className='relative text-black ' onSubmit={handleSubmit}>
                    <div className='grid grid-cols-1 gap-10 mb-5'>
                        <div className="flex flex-col gap-2">
                            <label htmlFor="phone" className=' font-medium text-lg '>
                                {t("number")}
                            </label>
                            <PhoneInput
                                id="phone"
                                international
                                defaultCountry="LY"
                                value={phone}
                                onChange={setPhone}
                                className="phone-input border  w-full h-full border-grayColor p-3 rounded-lg px-2 bg-white focus:outline-none"
                            />
                        </div>

                        <div className='flex flex-col gap-2'>
                            <Input
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                type='password'
                                name='password'
                                text={t("password")}
                                required
                            />
                            <div className='grid  w-full'>
                                <Link className='text-secondry justify-self-end' to="/auth/forget-password">
                                    {t("forget-password")}
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className='w-full bg-secondry rounded-lg  text-white cursor-pointer text-center'>
                        {loading ? (
                            <div className='flex py-2 justify-center'>
                                <Circles
                                    height="25"
                                    width="25"
                                    color="#fff"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                />
                            </div>
                        ) : (
                            <button
                                type="submit"
                                className='w-full cursor-pointer py-2'
                            >{t("login")}</button>
                        )}
                    </div>
                    <div className='my-10'>
                        <div className='w-full bg-grayColor flex-center h-[1px] '>
                            <div className=' text-black rounded-full w-14 h-14 bg-white flex-center p-3 absolute'>{t("or")}</div>
                        </div>
                    </div>

                    <button
                        onClick={() => loginWithGoogle()}
                        type="button"
                        className="bg-white w-full flex items-center justify-center gap-2 p-3 rounded-lg shadow-md text-lg"
                    >
                        <FcGoogle className="text-2xl" />
                        {t("sign-google")}
                    </button>
                   {/*  <button
                        onClick={loginWithApple}
                        type="button"
                        className="bg-black text-white w-full flex items-center justify-center gap-2 p-3 rounded-lg shadow-md text-lg"
                    >
                        <FaApple className="text-2xl" />
                        {t("sign-apple")}
                    </button> */}
                    {/* Register Link */}
                    <div className='pt-5 flex gap-1 justify-center'>
                        <p className='text-grayColor'>{t("dont-have-account")}</p>
                        <Link className='text-secondry' to="/auth/register">{t("register")}</Link>
                    </div>
                </form>
            </div>

        </div>
    )
}

export default LoginForm
